import { useLocation, Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { Package, Shapes, Printer, User, Wallet, ClipboardList, Shield, Users } from "lucide-react";
import { useTranslation } from "../LanguageContext";
import { useAuth } from "../AuthContext";

export default function Navbar({ isOpen, onClose }) {
  const { t } = useTranslation();
  const { can } = useAuth();
  const location = useLocation();
  const [activeItem, setActiveItem] = useState("");

  const navigationItems = [
    { label: t('nav.dashboard'), icon: <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" /></svg>, path: "/dashboard" },
    { label: t('nav.products'), icon: <Package className="w-4 h-4" />, path: "/products", permission: 'products.view' },
    { label: t('nav.variants'), icon: <Shapes className="w-4 h-4" />, path: "/variants", permission: 'variants.view' },
    { label: t('nav.invoices'), icon: <Printer className="w-4 h-4" />, path: "/invoices", permission: 'invoices.view' },
    { label: t('nav.clients'), icon: <User className="w-4 h-4" />, path: "/clients", permission: 'clients.view' },
    { label: t('nav.charges'), icon: <Wallet className="w-4 h-4" />, path: "/charges", permission: 'charges.view' },
    { label: t('nav.users'), icon: <Users className="w-4 h-4" />, path: "/users", permission: 'users.manage' },
    { label: t('nav.roles'), icon: <Shield className="w-4 h-4" />, path: "/roles", permission: 'roles.manage' },
    { label: t('nav.activity_log'), icon: <ClipboardList className="w-4 h-4" />, path: "/activity-logs", permission: 'activity_logs.view' },
  ];

  const visibleItems = navigationItems.filter(item => !item.permission || can(item.permission));

  useEffect(() => {
    const currentItem = navigationItems.find((item) => location.pathname.startsWith(item.path));
    setActiveItem(currentItem ? currentItem.label : "");
  }, [location, t]);

  return (
    <>
      {isOpen && <div className="fixed inset-0 max-md:h-[93vh] max-md:top-[7vh] z-30 bg-black/50 md:hidden" onClick={onClose} />}
      <div className={`fixed inset-y-0 left-0 z-40 w-60 max-md:h-[93vh] max-md:top-[7vh] bg-white border-r border-gray-200 transition-transform duration-200 ${isOpen ? "translate-x-0" : "-translate-x-full"} md:relative md:translate-x-0`}>
        <nav className="space-y-1 px-6 mt-12 max-md:mt-6">
          {visibleItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`flex w-full items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium ${activeItem === item.label ? "bg-[#171717] text-white" : "text-gray-900 hover:bg-gray-50"}`}
              onClick={onClose}
            >
              {item.icon}
              <span>{item.label}</span>
            </Link>
          ))}
        </nav>
      </div>
    </>
  );
}
